import { gql } from "graphql-request"

const bitcash = {
    name: 'bitcash',
    title: 'Bitcoin Cash',
    currency: 'BCH',
    check: true,
    regexp: '([\\W]|^)([q,p][\\da-zA-Z]{41})([\\W]|$)',
    noregxp: [
        '([\\W]|^)(bnb[0-9a-z]{2})([\\W]|$)',
        '([\\W]|^)(bnb[0-9a-z]{2)([\\W]|$)',
        '([\\W]|^)(T[\\w]{2})([\\W]|$)',
        '([\\W]|^)((cosmos1|terra1|tcro1|tcrocncl1)[a-zA-HJ-NP-Z0-9]{38,70})([\\W]|$)',
    ],

    query: gql`query ($network: BitcoinNetwork!, $address: String!) {
      bitcash: bitcoin(network: $network) {
        addressStats(address: {is: $address}){
          address{
            balance_usd: balance(in: USD)
            balance: balance
          }
        }
        ins: inputs(inputAddress: {is: $address}) {
          count: count(uniq: transactions)
          min_date: minimum(of: date)
          max_date: maximum(of: date)
        }
        outs: outputs( outputAddress: {is: $address}) {
          count: count(uniq: transactions)
          min_date: minimum(of: date)
          max_date: maximum(of: date)
        }  
      }
    }`,
}
export { bitcash }
